import "./fanous.css"
// import fanousGreen from "./assets/Shap_Green.svg"
// import fanousPink from "./assets/Shap_pink.svg"
// import fanousVolite from "./assets/Shap_Volite.svg"
import fanousBrown from "./assets/Shap_Brown.svg"
import fanousOrange from "./assets/Shap_Orange.svg"

export default function Fanous() {
    return (
        <div className="shapes">
            <div className="fanoos">
                <img src={fanousBrown} alt="shape-brown" />
            </div>
            <div className="fanoos">
                <img src={fanousOrange} alt="shape-orange" />
            </div>
            {/* <div className="fanoos">
                <img src={fanousVolite} alt="shape-volite" />
            </div>
            <div className="fanoos">
                <img src={fanousGreen} alt="shape-green" />
            </div> */}
        </div>
    )

}